import { render, staticRenderFns } from "./ConfigurazioneContabilitaTabellaIvaEditModalComponent.vue?vue&type=template&id=a1b244ea"
import script from "./ConfigurazioneContabilitaTabellaIvaEditModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTabellaIvaEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports